import { css } from "@linaria/core";

export const description = css`
  white-space: pre-wrap;
`;
